import { UserId } from '@beelday/common'
import { KnowledgeCheckStats } from '../knowledge-check'

/** Where a participant stands in a knowledge check. */
export type ParticipantStatus = keyof KnowledgeCheckStats

export type ParticipantGroup = {
	status: ParticipantStatus
	userIds: UserId[]
}

export type ParticipantOverview = {
	/** Always all three, in `STATUS_ORDER`, so the stage keeps its shape. */
	groups: ParticipantGroup[]
	finished: number
	total: number
}

/** The ones that are done come first. */
export const STATUS_ORDER: readonly ParticipantStatus[] = [
	'finished',
	'started',
	'notStarted',
]

/**
 * Sorts the room's participants by how far they are. The server and the
 * reducer keep the three lists apart, but a person must never be counted
 * twice if a list is ever caught mid-update: the furthest status wins.
 */
export const groupParticipants = (
	stats: KnowledgeCheckStats
): ParticipantOverview => {
	const placed = new Set<UserId>()
	const groups = STATUS_ORDER.map((status): ParticipantGroup => {
		const userIds = stats[status].filter(id => {
			if (placed.has(id)) {
				return false
			}
			placed.add(id)
			return true
		})
		return { status, userIds }
	})
	return {
		groups,
		finished: groups[0].userIds.length,
		total: placed.size,
	}
}
